import { UploaderDetails } from './UploaderDetails';

export default UploaderDetails;
